// extracted by mini-css-extract-plugin
module.exports = {"output":"AreaGraph_output__dnv_N","label":"AreaGraph_label__R6B4D"};